<script setup>
import { isotopeOptions } from '@/libraries/RadiationTreatmentObjects';
const props = defineProps(['codeObjects']) // whether it is a level or intracavitary chris
const isIsotopeOptions = (props.codeObjects == isotopeOptions)
const emits = defineEmits(['close'])
function dontClose(event) {
    event.stopPropagation();
}
</script>
<template>
    <div class="modal" @click="emits('close')">
        <div class="modal-content" @click="dontClose">


            <div class="container">
                <div v-for="codeObject in props.codeObjects" :key="codeObject">
                    <h3>{{ codeObject.name }}</h3>
                    <ul>
                        <li v-for="rule in codeObject.conditions">{{ rule }} </li>

                    </ul>
                </div>
                <li v-if="isIsotopeOptions">First and repeat applications refer to Intracavitary application of radium or
                    sealed sources including dilatation and curettage carried
                    out at the same time as application
                </li>
                <li>Note:
                    X325 may be claimed as an in-patient or out-patient service. Claims for in-patient services
                    must be in accordance with Other Terms and Definitions - #2 on page C1. If claimed as an outpatient
                    service, allow to all listed physicians. Payment for out-patient services must be made to
                    the registered Department of Radiology, in the case of a hospital, even though there is no
                    technical component listed. </li>
                <br>
            </div>

        </div>
    </div>
</template>
<style scoped lang="scss">
</style>